import React, { useEffect, useState } from 'react'
import Header from '../../components/header/Header'
import Footer from '../../components/footer/Footer'
import PageHeading from '../../components/pageHeading/PageHeading'
import Map from '../../assets/images/map.png'
import '../../../src/jobDetail.scss'
import { Button, Form } from 'react-bootstrap'
import { FileUploadIcon, StarOutline } from '../../components/Icons'
import UserImg from '../../../src/assets/images/user.jpg'
import { getFullName, twoDecimalPlaces } from '../../utils/common'
import { useDispatch } from 'react-redux';
import { setLoader } from '../../slice/commonSlice'
import { toast } from "react-toastify";
import { GOOGLE_MAPS_API_KEY, toast_error, toast_success } from '../../config/Constant'
import { uploadSelfie } from '../../services/auth.service'
import { apiUrl } from '../../environment'
import MapMarker from '../../components/mapMarker/MapMarker'

const JobDetailUser = ({ details, fetchDetails }) => {
  const [isSelfie, setSelfie] = useState(false);
  const [startSelfieFile, setStartSelfieFile] = useState(null);
  const [endSelfieFile, setEndSelfieFile] = useState(null);
  const [startSelfie, setStartSelfie] = useState(null);
  const [endSelfie, setEndSelfie] = useState(null);
  const dispatch = useDispatch();
  const [inlineItems, setInlineItems] = useState([])
    useEffect(()=>{
        if(details?.lineItemsData){
            let inlineData = convertToKeyValuePairs(details?.lineItemsData);
            setInlineItems(inlineData);
        }
    }, [details])
    function convertToKeyValuePairs(jsonString) {
      try {
        // Parse the JSON string into a JavaScript object
        const arrayOfObjects = JSON.parse(jsonString);
    
        // Check if the parsed data is an array
        if (!Array.isArray(arrayOfObjects)) {
          console.error('Input is not an array.');
          return [];
        }
    
        // Use map to transform each object into an array of key-value pairs
        return arrayOfObjects.map(obj => {
          // Use Object.entries to get an array of [key, value] pairs for each object
          const keyValuePairs = Object.entries(obj);
    
          // Use map again to transform each [key, value] pair
          const mappedPairs = keyValuePairs.map(([key, value]) => {
            // Here, you can modify or process the key and value as needed
            return { key, value };
          });
    
          // Return the modified object
          return mappedPairs;
        }).flat(); // Use flat to flatten the array of arrays
      } catch (error) {
        console.error('Error parsing JSON:', error.message);
        return [];
      }
    }
  const handleSelefie = () => {
    setSelfie(true);
  }
  const handleRemoveSelefie = () => {
    setSelfie(false);
  }
  const onFileChange = (e, type) => {
    if (type === 'start') {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          setStartSelfie(e.target.result);
        };
        reader.readAsDataURL(file);
        uploadSelfieFile(type, file)
      }

    } else if (type === 'end') {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          setEndSelfie(e.target.result);
        };
        reader.readAsDataURL(file);
        uploadSelfieFile(type, file)
      }
    }
  };
  const fetchCharge = () => {
    if (details?.calculatedPrice) {
      return twoDecimalPlaces(details?.calculatedPrice);
    } else {
      if (details?.durationUpdated) {
        let price = details?.unitPrice * details?.durationUpdated;
        return twoDecimalPlaces(price);
      } else {
        let price = details?.unitPrice * details?.durationExpected;
        return twoDecimalPlaces(price);
      }
    }
  }
  const fetchTotal = () => {
    if (details?.finalPrice) {
      let price = details?.finalPrice ? twoDecimalPlaces(details?.finalPrice) : details?.finalPrice
      return price;
    } else {
      if (details?.durationUpdated) {
        let price = details?.unitPrice * details?.durationUpdated;
        let total = price + details?.taxAmount;
        return twoDecimalPlaces(total);
      } else {
        let price = details?.unitPrice * details?.durationExpected;
        let total = price + details?.taxAmount;
        return twoDecimalPlaces(total);
      }
    }
  }

  const uploadSelfieFile = async (type, file) => {
    const formData = new FormData();
    if (type === 'start') {
      formData.append("startSelfie", file);
    }
    if (type === 'end') {
      formData.append("endSelfie", file);
    }
    formData.append("jobId", details?._id);

    await dispatch(setLoader(true));
    try {
      const response = await uploadSelfie(formData);
      await dispatch(setLoader(false));
      if (response?.status) {
        toast.success(response?.data?.message, toast_success);
        fetchDetails()
      } else {
        toast.error('No image found', toast_error)
      }
    } catch (error) {
      toast.error(error?.data?.message, toast_error)
      await dispatch(setLoader(false));
      console.error("Error data:", error);
    }
  };

  const fetchImge = (img) => {
    return `${apiUrl}/${img}`
  }
  return (
    <>
      <Header />
      <PageHeading title='Job Detail' />
      <div className='main-container'>
        <div className='job-detail-wrapper'>
          <div className='map-wrapper'>
            {/* <img src={Map} alt='Map' /> */}
            {details ? <MapMarker startAddress={details?.sender?.address} endAddress={details?.receiver?.address} apiKey={GOOGLE_MAPS_API_KEY} /> : null }
          </div>
          <div className='job-content-wrapper'>
            <div className='job-content-section'>
              <div className='job-content-titile'>Pickup Details</div>
              <div className='box-wrapper job-content'>
                <div className='job-title'>{getFullName(details?.sender?.firstName, details?.sender?.lastName)}</div>
                <div className='address'>{details?.sender?.address}</div>
                <div className='phone'>{details?.sender?.phone}</div>
              </div>
            </div>
            <div className='job-content-section'>
              <div className='job-content-titile'>{details?.jobType === 'ON' ? 'Add Start Job Selfie' : 'Start Job Selfie'}</div>

              <div className='box-wrapper browse'>
                {(details?.startSelfie || startSelfie) ?
                  <>
                    <div className='selfie-wrapper'>
                      <div className='selfie-img'>
                        <img src={details?.startSelfie ? fetchImge(details?.startSelfie) : startSelfie} alt='' />
                      </div>
                    </div>
                    {/* <Button variant='outline-primary' onClick={() => handleRemoveSelefie('start')}>
                      Remove
                    </Button> */}
                    {
                      details?.jobType === 'ON' ?
                        <Button variant='outline-primary' >
                          Browse
                          <input type='file' name="profilePic" onChange={(e) => onFileChange(e, 'start')} />
                        </Button> : null
                    }
                  </>
                  :
                  <>
                    <div><FileUploadIcon /></div>
                    <div>Upload a Selfie</div>
                    <Button variant='outline-primary' >
                      Browse
                      <input type='file' name="profilePic" onChange={(e) => onFileChange(e, 'start')} />
                    </Button>
                  </>
                }
              </div>

            </div>
            <div className='job-content-section'>
              <div className='job-content-titile'>Drop Details</div>
              <div className='box-wrapper job-content'>
                <div className='job-title'>{getFullName(details?.receiver?.firstName, details?.receiver?.lastName)}</div>
                <div className='address'>{details?.receiver?.address}</div>
                <div className='phone'>{details?.receiver?.phone}</div>
              </div>
            </div>
            {
              details?.startSelfie ?
                <div className='job-content-section'>
                  <div className='job-content-titile'>{details?.jobType === 'ON' ? 'Add End Job Selfie' : 'End Job Selfie'}</div>
                  <div className='box-wrapper browse'>
                    {(details?.endSelfie || endSelfie) ?
                      <>
                        <div className='selfie-wrapper'>
                          <div className='selfie-img'>
                            <img src={details?.endSelfie ? fetchImge(details?.endSelfie) : endSelfie} alt='' />
                          </div>
                        </div>
                        {/* <Button variant='outline-primary' onClick={() => handleRemoveSelefie()}>
                      Remove
                    </Button> */}
                        {
                          details?.jobType === 'ON' ?
                            <Button variant='outline-primary' >
                              Browse
                              <input type='file' name="profilePic" onChange={(e) => onFileChange(e, 'end')} />
                            </Button>
                            : null
                        }
                      </>
                      :
                      <>
                        <div><FileUploadIcon /></div>
                        <div>Upload a Selfie</div>
                        <Button variant='outline-primary' >
                          Browse
                          <input type='file' name="profilePic" onChange={(e) => onFileChange(e, 'end')} />
                        </Button>
                      </>
                    }
                  </div>
                </div> : null
            }


            <div className='job-content-section'>
              <div className='job-content-titile'>Payment Detail</div>
              <div className='payment-detail-wrap'>
                <table className='table'>
                  <tr>
                    <td width="800">Distance</td>
                    <td width="140">{details?.distance}</td>
                  </tr>
                  <tr>
                    <td>Charge</td>
                    <td>${fetchCharge()}</td>
                  </tr>
                  {
                                      inlineItems?.length > 0 ? 
                                      <>
                                          <tr>
                                      <td width="800" className='text-decoration-underline'>Additional Charges</td>
                                      <td width="140"></td>
                                  </tr>
                                  
                                  {
                                      inlineItems?.map((item, index)=>(
                                          <tr key={index}>
                                              <td width="800">{item?.key}</td>
                                              <td width="140">${item?.value}</td>
                                          </tr>
                                      ))
                                  }
                                      </> : null
                                  }
                  <tr>
                    <td>Helpr app fee & Transaction fee</td>
                    <td>${twoDecimalPlaces(details?.taxAmount)}</td>
                  </tr>
                  <tr>
                    <td>Total</td>
                    <td>${fetchTotal()}</td>
                  </tr>
                </table>
              </div>
            </div>
            {/* <div className='job-content-section'>
              <div className='job-content-titile'>
                <div>Share Review</div>
                <div className='rating'><StarOutline /> <StarOutline /> <StarOutline /><StarOutline /> <StarOutline /></div>
              </div>
              <Form>
                <Form.Group className="mb-3" controlId="description">
                  <Form.Label>Description</Form.Label>
                  <Form.Control as="textarea" rows={3} placeholder='Description' />
                </Form.Group>
                <div className="d-grid gap-2 w-100">
                  <Button variant="primary">Share Review</Button>
                </div>
              </Form>
            </div> */}
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default JobDetailUser